import React from 'react';
import ReactDOM from 'react-dom/client';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import App from './App';
import {InitialPageLanguage} from './lib/page-text';
import './styles.css';
import {initializePageLanguage} from './lib/i18n';

initializePageLanguage();

const queryClient = new QueryClient({
  defaultOptions: { queries: { retry: 1, staleTime: 30_000 } },
});

const basename = import.meta.env.BASE_URL.replace(/\/$/, '') || '/';

const router = createBrowserRouter([{ path: '*', element: <App /> }], { basename });

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <InitialPageLanguage><RouterProvider router={router} /></InitialPageLanguage>
    </QueryClientProvider>
  </React.StrictMode>,
);
